import { Injectable } from '@angular/core';
import olMap from 'ol/Map';
import { MapService } from 'src/app/services/map.service';
import {Fill, Stroke, Style, Text, Image, Circle} from 'ol/style';
import {unByKey} from 'ol/Observable';
import { VicentyToolControlService } from 'src/app/services/vicenty-tool-control.service';
import { toLonLat } from 'ol/proj';
import { LatLonDMS } from 'src/app/models/coord-dms';
import * as olProj from 'ol/proj';
import Feature from 'ol/Feature';
import LineString from 'ol/geom/LineString';
import { FeatureType } from 'src/app/models/EnumTypes';
import { PointsService } from 'src/app/services/points.service';
import { UtilsService } from 'src/app/services/utils.service';
import { Coordinate } from 'ol/coordinate';
import { CoordenateService } from 'src/app/services/coordenate.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DynamicTable } from 'src/app/popup/dynamic-table/dynamic-table.component';

@Injectable({
  providedIn: 'root'
})

export class RangeRingToolService {

  active : boolean;
  fullScreenMode : boolean = false;
  map: olMap;
  dblClickListener;
  latitude : number;
  longitude : number;
  latLonDms:LatLonDMS = new LatLonDMS();
  start : number = 50;
  end : number = 300;
  increments:number = 30;

  constructor(
    private mapService:MapService,
    public vicentyTool : VicentyToolControlService,
    private pointsService: PointsService,
    private utilsService: UtilsService,
    private rcsControl: CoordenateService,
    private popupService : BsModalService
  ) {

    this.map = mapService.getMap('map');
   }

   openFooter():void {
    this.active = true;
    this.clearListeners();
    this.dblClickListener = this.map.on("dblclick", this.dblClickHandler.bind(this));

  }

  hideFooter(){
    this.active = false;
    this.clearListeners();
  }
  closeFooter(){
    this.hideFooter();
    this.clearLayer();
  }
  dblClickHandler(evt) {


    const clickedNavaids: Feature[] = []
    this.map.forEachFeatureAtPixel(evt.pixel,
      function(feat : Feature){
        if(feat.get('featureType') == FeatureType.Navaid){
          clickedNavaids.push(feat);
        }
      },
      {
        hitTolerance: 5
      }
    );
    if(clickedNavaids.length == 0 ){
      const coords = toLonLat(evt.coordinate,this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");
      this.latitude = coords[1];
      this.longitude = coords[0];
      this.latLonDms.fromLat(this.latitude);
      this.latLonDms.fromLon(this.longitude);

      this.drawCircles();
      return;
    }
    const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    bsModalRef.content.entity = "Navaid";
    bsModalRef.content.type = "Select";
    bsModalRef.content.selectAllActive = false;
    bsModalRef.content.data = clickedNavaids;
    bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Navaids");
    bsModalRef.content.onClose.subscribe(result => {
      if (result != null && result.length > 0) {
        this.latitude = result[0].Latitude;
        this.longitude = result[0].Longitude;
        this.latLonDms.fromLat(this.latitude);
        this.latLonDms.fromLon(this.longitude);
      } else {
        const coords = toLonLat(evt.coordinate, this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857");
        this.latitude = coords[1];
        this.longitude = coords[0];
        this.latLonDms.fromLat(this.latitude);
        this.latLonDms.fromLon(this.longitude);
      }
      

      this.drawCircles();
    })
  }

  drawCircles() {
    this.clearLayer();
    for ( let distance = this.start; distance < this.end; distance += this.increments) {
      let featureArray: Feature[] = this.createCircleFeatures(distance);
      this.addCircleToMap(featureArray);
    }
  }

  calculateCirclePoints(radius): Coordinate[] {
	  const circlePoints: Coordinate[] = [];
		const radiusInMeters = this.utilsService.nmToMeters(radius);
		for (let azimuth:number = 0; azimuth <= 360; azimuth++) {
			let target: number[] = VicentyToolControlService.calculateDestinationPoint(this.latitude, this.longitude, azimuth, radiusInMeters);
			let targetCoordinate: Coordinate = [target[1], target[0]];
      targetCoordinate = olProj.transform(targetCoordinate, 'EPSG:4326',this.map.getView().getProjection());
			circlePoints.push(targetCoordinate);
		}
    return circlePoints;
  }

  createCircleFeatures(radius) {

    let features : Feature[] = [];

    const newFeature = new Feature({
      geometry: new LineString(this.calculateCirclePoints(radius)),
      featureType : FeatureType.RangeRingTool,
    });

    const style = function () {
      const zoom = this.map.getView().getResolution();
      let fontMultiplier = 200
      if(this.map.getView().getProjection().getCode() == 'EPSG:4326'){
        fontMultiplier = 0.6;
      }
      const font_size = 1/Math.pow(zoom, 1/2)*fontMultiplier;

      return [
        new Style({
          stroke: new Stroke({
            color: 'rgba(15,154,213)',
            width: 3
          }),
          fill: new Fill({
            color: 'rgba(15,154,213,0)',
          }),
          text: new Text({
            scale: font_size,
            font: font_size + 'px Calibri,sans-serif',
            offsetX: 0,
            offsetY: 7,
            overflow: false,
            fill: new Fill({
              color: 'rgba(15,154,213)',
            }),
            text: radius.toString() + ' [NM]'
          })
        })
      ];
    }.bind(this);
    newFeature.setStyle(style);
    features.push(newFeature);
    return features;

  }

  addCircleToMap(features : Feature []) {
    let source = this.pointsService.rangeRingToolLayer.childLayers[0].layers
    .find((element) => element.id === 'Range_Ring_Tool_Layer')
    .olLayer.getSource();

   features.forEach( feat => {
      source.addFeature(feat);
    });


  }

  clearLayer() {
    this.pointsService.rangeRingToolLayer.childLayers?.forEach(el => {
      el.layers.forEach(layer => {
        layer.olLayer.getSource().clear();
      })
    });

  }

  clearListeners() {
    unByKey(this.dblClickListener);
    this.map.removeEventListener("dblclick", null);
  }

}

